import { PatientFilterCategory } from '@shared/constants/PatientFilterCategory';

export enum PatientListTabIds {
  SdbTelemonitoring = 'SdbTelemonitoring',
  VentilationTelemonitoring = 'VentilationTelemonitoring',
}

export const PatientFilterCategoryPerTab: { [key in PatientListTabIds]: PatientFilterCategory } = {
  [PatientListTabIds.SdbTelemonitoring]: PatientFilterCategory.SleepTelemonitoring,
  [PatientListTabIds.VentilationTelemonitoring]: PatientFilterCategory.VentilationTelemonitoring,
};
